// extracted by mini-css-extract-plugin
export default {"container":"DevOpsTools_container__7JWo5","iconWrapper":"DevOpsTools_iconWrapper__kiy-x","iconItem":"DevOpsTools_iconItem__-RTCQ","icon":"DevOpsTools_icon__4sJsK"};